"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.settings = exports.Settings = void 0;
const Configuration_1 = require("../cutil/Configuration");
const is_blank_1 = __importDefault(require("@sedan-utils/is-blank"));
function parseEnv() {
    let env = (process.env.REACT_APP_ENV || process.env.REACT_APP_ENVIRONMENT) ?? "";
    if ((0, is_blank_1.default)(env))
        env = "development";
    return env;
}
const configuration = new Configuration_1.Configuration({
    ENV: parseEnv(),
    DAB: {
        development: "https://dashboard.brainllc.net",
        production: "https://dashboard.braininc.net",
    },
    API: {
        development: "https://api-dev.braininc.net",
        production: "https://api.braininc.net",
    },
    WS: {
        development: "https://pubsub-dev.braininc.net",
        production: "https://ws.braininc.net",
    },
    SignupRoleId: {
        development: "0c6615b4-2d4e-4d9d-b705-6ab670998781",
        production: "6af2feee-c175-4a05-83f9-73a165621a50",
    },
    S3CDN: "https://dopniceu5am9m.cloudfront.net/",
    publicDomain: "imagica.ai",
    birdEatsBugAppId: {
        development: "baefb2cf-094f-4273-9506-108149b6e047",
        production: "3927f621-70f6-4aa6-9480-c8189ebfc7f1",
    },
    amplitudeAPIKey: {
        development: "4ca79460f87019345a0b4c02a276633d",
        production: "aaf56118757d56e66a76e1dd0480ad90",
    },
    mapKey: {
        development: "pk.eyJ1IjoiMDAwb25seSIsImEiOiJjamlwY3NiMmowemNiM2tydHdvMXJzYzZvIn0.yXF2iwBffUk1Vz4H_nyoDQ",
        production: "pk.eyJ1IjoiMDAwb25seSIsImEiOiJjamlwY3NiMmowemNiM2tydHdvMXJzYzZvIn0.yXF2iwBffUk1Vz4H_nyoDQ",
    },
    ImagicaUrl: {
        development: "https://dashboard.brainllc.net/fot/#/editor/",
        production: "https://create.imagica.ai/fot/#/editor/",
    },
    creatorDomain: {
        development: "dashboard.brainllc.net,localhost",
        production: "create.imagica.ai,dashboard.braininc.net",
    },
    shareDomain: {
        development: "",
        production: "share.imagica.ai",
    },
    viewAssetsPath: "static/assets/230705/",
    googleOauthClientId: "1013138253307-vcholpklbmhga57cjona62km376sqj8g.apps.googleusercontent.com",
    googleAnalyticsId: {
        development: "G-9L0DXZKTVW",
        production: "G-8VYE78SCNG",
    },
    JiraAPIDomain: "https://brain-ai.atlassian.net",
    JiraAPIProjectID: "10017",
    JiraAPIIssueTypeID: "10028",
    templatesProjectUrl: {
        development: "https://dopniceu5am9m.cloudfront.net/develop/static/brus/web.config.json",
        production: "https://dopniceu5am9m.cloudfront.net/static/brus/web.config.json",
    },
    assets: "static/imagica.ai",
    naturalAiPath: "natural.ai/assets/font",
    corebeUrl: {
        development: "https://api-dev.braininc.net/stream/imagica-bff-dev",
        production: "https://api.braininc.net/stream/imagica-bff-dev",
    },
}, parseEnv(), sessionStorage, window.location.search);
class Settings {
    constructor(ENV, DAB, API, WS, SignupRoleId, S3CDN, publicDomain, birdEatsBugAppId, amplitudeAPIKey, mapKey, ImagicaUrl, creatorDomain, shareDomain, viewAssetsPath, googleOauthClientId, googleAnalyticsId, JiraAPIDomain, JiraAPIProjectID, JiraAPIIssueTypeID, templatesProjectUrl, assets, naturalAiPath, corebeUrl) {
        this.ENV = ENV;
        this.DAB = DAB;
        this.API = API;
        this.WS = WS;
        this.SignupRoleId = SignupRoleId;
        this.S3CDN = S3CDN;
        this.publicDomain = publicDomain;
        this.birdEatsBugAppId = birdEatsBugAppId;
        this.amplitudeAPIKey = amplitudeAPIKey;
        this.mapKey = mapKey;
        this.ImagicaUrl = ImagicaUrl;
        this.creatorDomain = creatorDomain;
        this.shareDomain = shareDomain;
        this.viewAssetsPath = viewAssetsPath;
        this.googleOauthClientId = googleOauthClientId;
        this.googleAnalyticsId = googleAnalyticsId;
        this.JiraAPIDomain = JiraAPIDomain;
        this.JiraAPIProjectID = JiraAPIProjectID;
        this.JiraAPIIssueTypeID = JiraAPIIssueTypeID;
        this.templatesProjectUrl = templatesProjectUrl;
        this.assets = assets;
        this.naturalAiPath = naturalAiPath;
        this.corebeUrl = corebeUrl;
    }
    /**
     * 获取s3的图片
     * @param assetsName
     */
    getViewAssetsPath(assetsName) {
        return `${this.S3CDN}${this.viewAssetsPath}${assetsName}`;
    }
}
exports.Settings = Settings;
exports.settings = new Settings(configuration.extract("ENV"), configuration.extract("DAB"), configuration.extract("API"), configuration.extract("WS"), configuration.extract("SignupRoleId"), configuration.extract("S3CDN"), configuration.extract("publicDomain"), configuration.extract("birdEatsBugAppId"), configuration.extract("amplitudeAPIKey"), configuration.extract("mapKey"), configuration.extract("ImagicaUrl"), configuration.extract("creatorDomain").split(","), configuration.extract("shareDomain").split(","), configuration.extract("viewAssetsPath"), configuration.extract("googleOauthClientId"), configuration.extract("googleAnalyticsId"), configuration.extract("JiraAPIDomain"), configuration.extract("JiraAPIProjectID"), configuration.extract("JiraAPIIssueTypeID"), configuration.extract("templatesProjectUrl"), configuration.extract("assets"), configuration.extract("naturalAiPath"), configuration.extract("corebeUrl"));
